import _ from "lodash";

function toFixed(num: number) {
  num = Math.round(num * 10) / 10;
  let numString = num.toString();
  if (!numString.includes(".")) return num;
  return numString.length === 2
    ? numString.slice(0, numString.indexOf(".") + 3)
    : numString.slice(0, numString.indexOf(".") + 2);
}

function roundFloat(value: number | undefined, decimals: number) {
  if (!value) return "0.0";
  return value.toFixed(decimals);
}

// todo cleanup
function wholeNumberToString(num: number | undefined) {
  if (!num) return 0;
  return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
}

function longDate(date: string | null) {
  if (!date) return "";
  let newDate = date.substr(5, 10) + "-" + date.substr(0, 4); // need to move the year to the end with a seperator
  return newDate.replace(/-/g, "/");
}

function formatDateToLocale(date: Date) {
  return date.toLocaleDateString();
}

function backToTheFuture(date: string, daysBack: number) {
  const actualDate = new Date(date);
  return formatDateToLocale(
    new Date(actualDate.setDate(actualDate.getDate() - daysBack))
  );
}

function formatReportDate(date: string, timeStamp: boolean = true) {
  const newDate = longDate(date);
  return `${newDate}${timeStamp ? ", 11:59 PM" : ""}`;
}

function refAreaCalc(currentDate: string | null) {
  if (!currentDate) return "";
  let date = new Date(currentDate);
  date = new Date(date.setDate(date.getDate() - 4));
  let month = (date.getMonth() + 1).toString();
  let day = date.getDate().toString();
  const year = date.getFullYear().toString();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

function formatMapDate(date: string) {
  let dd = date.substring(0, 2);
  let mm = date.substring(2, 4);
  let yyyy = date.substring(4, 10);
  let reportDate = new Date(mm + "/" + dd + "/" + yyyy);
  reportDate.setDate(reportDate.getDate() - 1);
  var options = { year: "numeric", month: "2-digit", day: "2-digit" };
  let newReportDate = reportDate.toLocaleDateString("en-US", options);
  newReportDate = newReportDate.replace(/\//g, "-");
  let reformatDate =
    newReportDate.substr(6, 10) + "-" + newReportDate.substr(0, 5);
  return reformatDate;
}

function sum(numbers: (number | null)[]) {
  return _.reduce(numbers, (a, b) => a + (b ? b : 0), 0);
}

function average(numbers: (number | null)[]) {
  return (
    sum(numbers) / (numbers.filter((number) => number !== null).length || 1)
  );
}

function sumTotal(numbers: [number | null, number | null][]) {
  return (
    sum(numbers.map((number) => number[0])) /
    sum(numbers.map((number) => number[1]))
  );
}

function window(
  _number: number,
  index: number,
  array: [number | null, number | null][]
) {
  return _.slice(
    array,
    Math.max(0, index - 6),
    Math.min(array.length, index + 1)
  );
}

function movingAverage(numbers: (number | null)[]) {
  return (_.chain(numbers)
    .map(window)
    .map(average)
    .value() as unknown) as number[];
}

function movingSum(numbers: [number | null, number | null][]) {
  return (_.chain(numbers)
    .map(window)
    .map(sumTotal)
    .value() as unknown) as number[];
}

function makeWhole(number: number, percentage = true) {
  return Number.isNaN(number)
    ? 0
    : percentage
    ? parseFloat((number * 100).toFixed(1))
    : Math.round(number);
}

function objectifyData<D, T>(data: D, indexes: number[]): T {
  let objectedData: any[] = [];

  (Object.keys(data) as Array<keyof typeof data>).forEach((key) => {
    ((data[key] as unknown) as Array<string | number | null>).forEach(
      (value, index) => {
        // check to see if the index matches the items in our predefined index set above
        if (indexes.includes(index)) {
          // check to see if the record already exists to (a) add info to or (b) create new
          // this is a pattern kept throughout the useDashboardData hook
          const existingRecord = objectedData.find(
            (record) => record && record.index === index
          );

          if (existingRecord) {
            const existingIndex = objectedData.findIndex(
              (record) => record.index === existingRecord.index
            );

            objectedData[existingIndex] = {
              ...existingRecord,
              [key]: value,
            };
          } else {
            objectedData.push({
              index: index,
              [key]: value,
            });
          }
        }
      }
    );
  });

  return (objectedData as unknown) as T;
}

export {
  toFixed,
  longDate,
  refAreaCalc,
  formatReportDate,
  wholeNumberToString,
  roundFloat,
  formatMapDate,
  movingAverage,
  makeWhole,
  backToTheFuture,
  formatDateToLocale,
  objectifyData,
  movingSum,
};
